import React, { PureComponent } from 'react';
import styleable from 'react-styleable';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Header } from '@3plearning/react-components';

import css from './page-header.scss';

import { SELECTED_REPORT } from '../report-filters/filter-constants';

import ConnectedReportFilters from '../report-filters/report-filters';

/**
 * PAGE HEADER
 * ------------------
 * Displayed at top section of page.
 * Connected with redux to manage the subtitle report name
 */
class PageHeader extends PureComponent {
    static propTypes = {
        // Value for report filter
        selectedReport: PropTypes.object,
        // Should show the connected filters
        showFilters: PropTypes.bool
    };

    constructor(props) {
        super(props);

        this.text = {
            emptyString: '',
            headerTitle: 'Page Header - Reporting'
        };
    }

    getTitle = () => {
        const i18n = window.i18n;
        const { headerTitle, emptyString } = this.text;

        if (i18n) return i18n._(headerTitle);

        return emptyString;
    };

    getSubtitle = () => {
        const { emptyString } = this.text;

        if (this.props.selectedReport.name) {
            const i18n = window.i18n;
            const key = `Report Filters - ${this.props.selectedReport.name}`;

            return i18n._(key);
        }

        return emptyString;
    };

    getHeaderTitle = () => {
        const i18n = window.i18n;
        const { headerTitle, emptyString } = this.text;

        if (i18n) {
            return i18n._(headerTitle);
        }

        return emptyString;
    };

    render() {
        const { showFilters } = this.props;

        return (
            <Header
                title={this.getTitle()}
                subtitle={this.getSubtitle()}
                className={css['page-header']}
            >
                {showFilters && <ConnectedReportFilters />}
            </Header>
        );
    }
}

PageHeader.defaultProps = {
    showFilters: true
};

function mapStateToProps(state) {
    return {
        selectedReport: state.activeFilters[SELECTED_REPORT]
    };
}

export default connect(mapStateToProps)(styleable(css)(PageHeader));



// WEBPACK FOOTER //
// ./components/page-header/page-header.js